import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.swatch/swatch-landing.htm'
import $session from 'servicestack/session'
import SwatchCountPrompt from 'emun.swatch/swatchcount-prompt'

class SwatchLandingController {
    constructor($rootScope, $state, createAutoQuery, createServiceBus) {
        basicController(this)
        this.$state = $state;
        this.$session = $session;
    }
    create(){
        const $ctrl = this;
        SwatchCountPrompt.open({model: {}}).then(() => $ctrl.load());
    }
}

let SwatchLanding = {
    controller: SwatchLandingController,
    require:{
        container: '^swatchContainer'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SwatchLanding;



